import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'react-jss'
import { withTranslation } from 'react-i18next'
import compose from '@shopify/react-compose'

import WifiCredentials from 'components/ran/wifi-credentials'
import ConfirmationItem from 'components/confirmation-item'

import confirmationStyles from './confirmation-content-style'

import ConnectionInstructions from '../connection-instructions'
import { dateToLocaleString } from 'helpers/date'

const RenewalConfirmation = ({ room, t, classes, i18n }) => {
  const date = dateToLocaleString({ date: room.end_date, language: i18n.language })
  return (
    <Fragment>
      <ConfirmationItem>
        <span dangerouslySetInnerHTML={{ __html: t('ran_renewal_confirmation.step_1', { date }) }} />
      </ConfirmationItem>
      <p className={classes.confirmationText}>
        <span>{t('ran_renewal_confirmation.step_2' )}</span>
      </p>
    </Fragment>
  )
}

const CreationConfirmation = ({ room, t }) => (
  <Fragment>
    <ConfirmationItem>{t('ran_activation_confirmation.step_1')}</ConfirmationItem>
    <ConfirmationItem isPending>{t('ran_activation_confirmation.step_2', { network: room.ssid })}</ConfirmationItem>
  </Fragment>
)

const ConfirmationContent = ({ theme, t, room, i18n }) => {
  const classes = confirmationStyles(theme)
  const confirmationProps = { t, room, i18n, classes }

  return (
    <Fragment>
      { room.is_renewed ? <RenewalConfirmation {...confirmationProps}/> : <CreationConfirmation {...confirmationProps} /> }
      <div className={classes.psk}>
        <WifiCredentials psk={room.psk} ssid={room.ssid}/>
      </div>
      <p className={classes.confirmationText}>
        <span dangerouslySetInnerHTML={{ __html: t('ran_activation_confirmation.text_email') }} />
      </p>
      <ConnectionInstructions room={room} hasWarning={!room.is_renewed} />
    </Fragment>
  )
}

ConfirmationContent.propTypes = {
  room: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}

export default compose(
  withTheme,
  withTranslation(),
)(ConfirmationContent)


